import { Button, useTheme } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'

const MSG = defineMessages({
  dismiss: {
    id: 'DismissButton.dismiss',
    defaultMessage: 'Dismiss'
  }
})

export const DismissButton = ({ onClick, trackingContext }: { onClick?: () => void; trackingContext: string }) => {
  const intl = useIntl()
  const { theme } = useTheme()

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
    localStorage.setItem('dismissedOwnAHome', 'true')
  }

  return (
    <Button
      variant='outline'
      size='sm'
      borderColor={theme.isLightThemeType ? 'blackAlpha.300 !important' : 'whiteAlpha.300 !important'}
      backgroundColor='whiteAlpha.100'
      px={4}
      border='1px solid'
      color={theme.isLightThemeType ? 'brand.500' : 'brand.700'}
      _hover={{
        // @ts-ignore
        color: theme.isLightThemeType ? 'brand.800' : 'brand.800'
      }}
      tracking={{
        guid: 'eesemo3EB2arfnYSDFfjNi',
        ui_context: trackingContext,
        descriptor: 'Dismiss button'
      }}
      onClick={handleClick}
    >
      {intl.formatMessage(MSG.dismiss)}
    </Button>
  )
}
